import React from 'react';
import { User } from 'lucide-react';
import ParticipantSelector from '../components/ParticipantSelector';
import { useField, useFormikContext } from 'formik';

export default function ParticipantField({
    count,
    onClick,
    name,
    showParticipantSelector,
}) {
    const [field] = useField(name);
    const { setFieldValue } = useFormikContext();
    const totalParticipants =
        field.value?.adults || 0 + field.value?.children || 0;

    return (
        <>
            <div
                className="flex flex-1 w-full items-center p-4 border lg:border-l-0 border-gray-200 cursor-pointer rounded-full lg:rounded-none "
                onClick={onClick}
            >
                <User className="text-gray-400 mr-2 flex-shrink-0" size={20} />
                <span className="text-gray-700">{totalParticipants}</span>
            </div>
            {showParticipantSelector && (
                <ParticipantSelector
                    name={name}
                    field={field}
                    setFieldValue={setFieldValue}
                />
            )}
        </>
    );
}
